<template>
    <transition :name="name">
            <slot/>
    </transition>
</template>

<script>
export default {
    name: 'sp-transition',
    props: {
        name: {
            type: [String],
            required: true,
        },
    }
}
</script>

<style lang="scss" scoped>

.slide-x-left-bounce {
    &-leave-active,
    &-enter-active {
        transition: .3s cubic-bezier(.74,.32,0,1.32);
    }
    &-enter {
        transform: translate(100%, 0);
    }
    &-leave-to {
        transform: translate(100%, 0);
    }
}

.slide-x-left {
    &-leave-active,
    &-enter-active {
        transition: .15s cubic-bezier(.5,.24,.37,.98);
    }
    &-enter {
        transform: translate(100%, 0);
    }
    &-leave-to {
        transform: translate(100%, 0);
    }
}

.slide-y-top {
    &-leave-active,
    &-enter-active {
        transition: .3s cubic-bezier(1,-0.71,.06,1.56);
    }
    &-enter {
        transform: translate(0, -100%);
    }
    &-leave-to {
        transform: translate(0, -100%);
    }
}

</style>
